<div class="no-results-container">
  <div class="no-results">
    <mat-icon fontIcon="developer_board_off"></mat-icon>
    <div>{{ message }}</div>
  </div>
</div>
